var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 17 19.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1597881249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.5 15.75C5.5 16.5456 5.81607 17.3087 6.37868 17.8713C6.94129 18.4339 7.70435 18.75 8.5 18.75C9.29565 18.75 10.0587 18.4339 10.6213 17.8713C11.1839 17.3087 11.5 16.5456 11.5 15.75",
    stroke: "var(--stroke-0, #393B42)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.74999 7.5C1.74999 5.70979 2.46115 3.9929 3.72702 2.72703C4.99289 1.46116 6.70978 0.75 8.49999 0.75C10.2902 0.75 12.0071 1.46116 13.273 2.72703C14.5388 3.9929 15.25 5.70979 15.25 7.5C15.25 9.2317 15.7154 11.3713 16.1661 13.0375C16.5274 14.373 15.5439 15.75 14.1604 15.75H2.83941C1.45595 15.75 0.472464 14.3731 0.833728 13.0377C1.28454 11.3712 1.74999 9.23139 1.74999 7.5Z",
    stroke: "var(--stroke-0, #393B42)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.05c51b74bec19e804a2d1bf4ad6abc83.svg";
export { ForwardRef as ReactComponent };